(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vibra-mosaic-panel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  var target = event.target instanceof Element ? event.target : event.target.parentElement;
  var link = target && target.closest('a[data-note-finder-launch]');
  if (!link) return;
  var width = Math.min(430, screen.availWidth);
  var height = Math.max(320, Math.min(820, screen.availHeight - 80));
  var left = (screen.availLeft || 0) + Math.max(0, Math.round((screen.availWidth - width) / 2));
  var top = (screen.availTop || 0) + Math.max(0, Math.round((screen.availHeight - height) / 2));
  try {
    var popup = window.open(link.href, '_blank', 'popup=yes,width=' + width + ',height=' + height + ',left=' + left + ',top=' + top + ',resizable=yes,scrollbars=yes');
    if (popup) {
      event.preventDefault();
      event.stopImmediatePropagation();
      try { popup.opener = null; popup.focus(); } catch (error) {}
    }
  } catch (error) {}
}, { capture: true });
  } catch(e) { console.error(e); }
})();

})();
